import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var MessageDtoFailureReasonInline;
(function (MessageDtoFailureReasonInline) {
    MessageDtoFailureReasonInline["PROMPT_TOO_LARGE"] = "PROMPT_TOO_LARGE";
})(MessageDtoFailureReasonInline || (MessageDtoFailureReasonInline = {}));
export var MessageDtoRoleInline;
(function (MessageDtoRoleInline) {
    MessageDtoRoleInline["USER"] = "USER";
    MessageDtoRoleInline["ASSISTANT"] = "ASSISTANT";
})(MessageDtoRoleInline || (MessageDtoRoleInline = {}));
export var MessageDtoStatusInline;
(function (MessageDtoStatusInline) {
    MessageDtoStatusInline["PENDING"] = "PENDING";
    MessageDtoStatusInline["IN_PROGRESS"] = "IN_PROGRESS";
    MessageDtoStatusInline["COMPLETED"] = "COMPLETED";
    MessageDtoStatusInline["FAILED"] = "FAILED";
})(MessageDtoStatusInline || (MessageDtoStatusInline = {}));
/** An agent's classification. REGULAR and PRESENTATION agents appear in the chat selector; REPORTING agents drive the conversational report-spec tools and are fetched only by the reporting context. */
export var AgentCategory;
(function (AgentCategory) {
    AgentCategory["REGULAR"] = "REGULAR";
    AgentCategory["PRESENTATION"] = "PRESENTATION";
    AgentCategory["REPORTING"] = "REPORTING";
})(AgentCategory || (AgentCategory = {}));
/** A getAgents filter that expands to a set of categories: CHAT -> [REGULAR, PRESENTATION], REPORT -> [REPORTING], ALL -> every category. */
export var AgentCategoryBundle;
(function (AgentCategoryBundle) {
    AgentCategoryBundle["ALL"] = "ALL";
    AgentCategoryBundle["CHAT"] = "CHAT";
    AgentCategoryBundle["REPORT"] = "REPORT";
})(AgentCategoryBundle || (AgentCategoryBundle = {}));
/** Discriminator for a message's structured (non-text) output, carried as the type of the structuredOutput envelope. Add a value here for each new output kind. REPORT_SPEC and CLARIFICATION are produced by the assistant; CLARIFICATION_ANSWER is attached by the client to the user reply that answers a CLARIFICATION. */
export var MessageOutputType;
(function (MessageOutputType) {
    MessageOutputType["REPORT_SPEC"] = "REPORT_SPEC";
    MessageOutputType["CLARIFICATION"] = "CLARIFICATION";
    MessageOutputType["CLARIFICATION_ANSWER"] = "CLARIFICATION_ANSWER";
})(MessageOutputType || (MessageOutputType = {}));
export var ModelTypeEnum;
(function (ModelTypeEnum) {
    ModelTypeEnum["TEXT"] = "TEXT";
    ModelTypeEnum["IMAGE"] = "IMAGE";
    ModelTypeEnum["VIDEO"] = "VIDEO";
})(ModelTypeEnum || (ModelTypeEnum = {}));
export var TargetingMode;
(function (TargetingMode) {
    TargetingMode["EXCLUDE"] = "EXCLUDE";
    TargetingMode["INCLUDE"] = "INCLUDE";
})(TargetingMode || (TargetingMode = {}));
export var LanguageCode;
(function (LanguageCode) {
    LanguageCode["DE"] = "DE";
    LanguageCode["EN"] = "EN";
    LanguageCode["FR"] = "FR";
    LanguageCode["IT"] = "IT";
})(LanguageCode || (LanguageCode = {}));
export var FormOfCommunication;
(function (FormOfCommunication) {
    FormOfCommunication["INFORMAL"] = "INFORMAL";
    FormOfCommunication["FORMAL"] = "FORMAL";
})(FormOfCommunication || (FormOfCommunication = {}));
export var ContactRole;
(function (ContactRole) {
    ContactRole["SALES"] = "SALES";
    ContactRole["CUSTOMER"] = "CUSTOMER";
})(ContactRole || (ContactRole = {}));
export var VisibilityMode;
(function (VisibilityMode) {
    VisibilityMode["VISIBLE"] = "VISIBLE";
    VisibilityMode["HIDDEN"] = "HIDDEN";
    VisibilityMode["TRANSPARENT"] = "TRANSPARENT";
})(VisibilityMode || (VisibilityMode = {}));
